<div class="principal-container flex">
  <div class="menu-routes" *ngIf="showSidebar" [ngClass]="{'menu-routes--show':showSidebar, 'open-side-animation':openSideMenuAnimation, 'close-side-animation':closeSideMenuAnimation}">
    <div class="menu-routes__inner">
        <div class="menu-routes__title menu-routes__title--default flex align-y">
          <span class="menu-routes__text menu-routes--padding-routes flex">{{'NUM_ROUTES' | translate}}</span>
          <i *ngIf="device !== 'desktop'" (click)="closeSideMenu()" class="material-icons menu-routes__title--close notranslate">close</i>
        </div>
        <div class="flex align-y space-between">
          <div class="width_arrow flex align-y">
            <i *ngIf="startIndex != -1" (click)="previousItem()" class="left-arrow material-icons notranslate">play_arrow</i>
          </div>
          <div class="flex align-y">
            <ng-container *ngFor="let route of map?.routes; let i = index">
              <div *ngIf="(i > startIndex) && (i < endIndex)" [style.background-color]="route.isSelected ? route?.color : 'white'" [style.border-color]="!route.isSelected ? route?.color : 'none'" [style.opacity]="!route.isSelected ? '0.5' : '1'" class="menu-routes__icon-list flex align-y align-x routes-icon-animation" (click)="showStopList(route)">
                <i [style.color]="route.isSelected ? 'white' : route?.color" class="material-icons menu-routes__route-icons notranslate">directions_bus</i>
              </div>
            </ng-container>
          </div>
          <div class="width_arrow flex align-y">
            <i *ngIf="endIndex <= map?.routes.length - 1" (click)="nextItem()" class="right-arrow material-icons notranslate">play_arrow</i>
          </div>
        </div>
        <div>
          <ul *ngFor="let route of map?.routes; let i = index" class="menu-routes__list">
            <ng-container *ngIf="route?.showStopList">
              <div class="menu-routes__title flex align-y" [ngStyle]="{'background-color':route?.color}">
                   <span class="menu-routes__text menu-routes--padding-routes flex color-white">{{route.name}}</span>
                   <div class="onoffswitch">
                      <input type="checkbox" name="onoffswitch" class="onoffswitch-checkbox" id="myonoffswitch" (click)="onRouteClick(route)">
                      <label class="onoffswitch-label" [style.background-color]="route.isSelected ? '#10E310' : 'black'" for="myonoffswitch"><div class="onoffswitch-label-ball" [style.right]="route.isSelected ? '0px' : '22px'"></div></label>
                  </div>
              </div>
              <li class="menu-routes__row flex align-y" *ngFor= "let stop of route.stoppingPlaces" (click)="onRouteStopClick(route, stop)">
                <span class="menu-routes__stop-number" [ngStyle]="{'background-color':route?.color}"><span *ngIf="stop.number !== null">{{stop.number}}</span> <span *ngIf="stop.number == null && stop.placeOrder">{{stop.placeOrder}}</span></span>{{stop.name}}
              </li>
            </ng-container>
          </ul>
        </div>
    </div>
  </div>
  <!-- <div class="map-container">
    <div class="map" id="mapbox"></div>
  </div> -->
  <div class="map-container">
    <agm-map class="map" *ngIf="loaded" #agmMap
      [gestureHandling]="'cooperative'" 
      [scrollwheel]=null
      [styles]="mapStyleConfig"
      [zoom]="map.zoom" 
      [streetViewControl]="false" 
      [latitude]="centerLat" 
      [longitude]="centerLng"
      [fullscreenControl]="true"
      (mapClick)="mapClick()" 
      (zoomChange)="zoomChange($event)"
      (mapReady)="mapReady()">
      <ng-container *ngFor="let route of map.routes">
          <agm-polyline
                [clickable] = "false"
                [strokeWeight] = "4"
                [strokeColor]="route?.isSelected ? route?.color : 'transparent'">
            <agm-polyline-point *ngFor="let point of route.routePoints" [latitude]="point.lat" [longitude]="point.lng"> </agm-polyline-point>
          </agm-polyline>
          <ng-container *ngFor="let attachedRoute of route.attachedPoints">
            <agm-polyline
                [clickable] = "false"
                [strokeWeight] = "2"
                [strokeColor]="route?.isSelected ? '#000' : 'transparent'">
              <agm-polyline-point *ngFor="let point of attachedRoute" [latitude]="point.lat" [longitude]="point.lng"> </agm-polyline-point>
            </agm-polyline>
          </ng-container>
          <ng-container *ngIf="mapZoomControl > limitMapZoom">
            <ng-container *ngIf="route?.isSelected">
              <agm-marker *ngFor="let stop of route.stoppingPlaces" 
                      [latitude]="stop.lat" 
                      [longitude]='stop.lng'
                      (markerClick)='onMarkerClick(stop,route)'
                      [label]="{color: 'white',fontSize:'20px',fontWeight:'bold',text: ((stop?.number == null && stop?.placeOrder) ? stop?.placeOrder.toString() : stop?.number.toString())}"
                      [iconUrl]="stop?.icon"
                      [zIndex]="route?.zIndex"> 
                      <agm-info-window [isOpen]='stop?.isSelected == true'
                                (infoWindowClose)='onInfoWindowClickOnClose()'>
                                <span>{{stop.number == null && stop.placeOrder ? stop.placeOrder : stop.number}} - </span>
                                <span> {{stop?.name}}</span>
                              </agm-info-window>  
              </agm-marker>
              <agm-marker [zIndex]="1" [latitude]="currentPosition?.coords.latitude" [longitude]="currentPosition?.coords.longitude" [iconUrl]="currentPositionIconUrl"></agm-marker>
            </ng-container>
          </ng-container>
      </ng-container>
      <ng-container *ngIf="mapPois?.length > 0 && mapZoomControl > limitMapZoom">
          <agm-marker class='monument' *ngFor="let poi of mapPois" 
            [latitude]="poi.lat" 
            [longitude]='poi.lng'
            [iconUrl]="poi.icon" 
            [zIndex]="9">
              <agm-info-window>
                  <span>{{poi.name}}</span>
              </agm-info-window>  
        </agm-marker>
      </ng-container>
    </agm-map>
  </div>
  <div class="side-menu" *ngIf="device == 'mobile' && !showSidebar">
    <button (click)="openSideMenu()" class="side-menu__btn pointer"><span class="side-menu__icon" [ngClass]="{'show-icon':!showSidebar}"></span></button>
  </div>
</div>
<svg id="svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 64 64" width="32" height="32" style="background: transparent; border-radius: 50%; transform: rotate(-90deg);"></svg>